import { IndustrialProcessSchema, IndustrialProcessType } from "../types";

export const isSurfaceTreatmentProcessStep = (processStep: {
  industrialProcess: IndustrialProcessType;
}) => {
  return (
    processStep.industrialProcess === IndustrialProcessSchema.enum.SURFACE_TREATMENT ||
    processStep.industrialProcess === IndustrialProcessSchema.enum.OUTSOURCING
  );
};
